export {
  NDLKotenOCR,
  type SimpleInitOptions,
  type ProcessOptions,
  type ProcessResult
} from './ndl-koten-ocr';

export { RTMDet } from './layout-detector';
export { PARSEQ } from './text-recognizer';
export { ReadingOrderProcessor, loadConfig as loadReadingOrderConfig } from './reading-order';
export { OutputGenerator, loadConfig as loadOutputConfig } from './output-generator';

// Worker版のエクスポート（別ファイルに分離する方が良い）
export { NDLKotenOCRWorker } from './worker/ndl-koten-ocr-worker';

// TEI/XML変換
export { TEIConverter, type TEIConversionData } from './tei-converter';

// IIIFマニフェスト処理
export { IIIFProcessor, type IIIFImageInfo, type IIIFProcessOptions } from './iiif-processor';

export type {
  Detection,
  RecognizedDetection,
  OCRResult,
  LayoutConfig,
  RecognizerConfig,
  ReadingOrderConfig,
  OutputConfig
} from './types';